import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    if (Env.mobileCSS) return false;
    this.DOM = {};
    this.DOM.view = this.element;
    //!
    this.VARS = {
      EASE: {
        TYPE: "cubic.inOut",
        DURATION: 0.8,
      },
    };
    this.VARS.NEW_SLIDE = 0;
    this.VARS.CURRENT_SLIDE = 0;
    this.VARS.IS_ANIMATING = false;
    this.VARS.DIRECTION = 0;
    //!
    this.FX = {};
    this.FX.targets = [];
    //! Fns

    gsap.delayedCall(Env.timingDelayFx / 1000, () => {
      this.makeTargets();
      this.makeSticky();
      this.events();
      gsap.delayedCall(0.1, () => {
        this.setActive();
      });
    });
  }

  events() {
    if (typeof this.ref.restartSlideshow != "undefined") {
      for (let btn of this.ref.restartSlideshow) {
        btn.addEventListener("click", () => {
          this.triggerScroll(0);
          // window.scrollTo(0, 0);
        });
      }
    }
  }

  makeSticky() {
    this.sticky = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: "top top",
      end: "bottom top",
      markers: false,
      scrub: true,
      pin: this.ref.slideshow[0],
      pinSpacing: true,
      invalidateOnRefresh: true,
    });
  }

  makeTargets() {
    for (let [i, target] of this.ref.target.entries()) {
      const instance = ScrollTrigger.create({
        trigger: target,
        start: "top center",
        end: "bottom center",
        onEnter: () => {
          this.triggerScroll(i);
        },
        onEnterBack: () => {
          this.triggerScroll(i);
        },
      });
      this.FX.targets.push(instance);
    }
  }

  move() {
    // Direction
    if (this.VARS.CURRENT_SLIDE > this.VARS.NEW_SLIDE) {
      this.VARS.DIRECTION = -1;
    } else {
      this.VARS.DIRECTION = 1;
    }
    // get DOM
    const DOM = {};
    DOM.currentSlide = this.ref.slide[this.VARS.CURRENT_SLIDE];

    if (DOM.currentSlide != null) {
      DOM.currentBG = DOM.currentSlide.querySelector(".fxVisualContainer");
    }
    DOM.activeSlide = this.ref.slide[this.VARS.NEW_SLIDE];
    DOM.activeBG = DOM.activeSlide.querySelector(".fxVisualContainer");
    // Tween
    const tl = gsap.timeline();
    this.VARS.IS_ANIMATING = true;
    tl.add([
      gsap.fromTo(
        DOM.currentBG,
        {
          y: `0%`,
        },
        {
          y: `${-100 * this.VARS.DIRECTION}%`,
          duration: this.VARS.EASE.DURATION,
          ease: this.VARS.EASE.TYPE,
          onStart: () => {
            gsap.set(DOM.currentSlide, { zIndex: 20 });
          },
        }
      ),
      gsap.fromTo(
        DOM.activeBG,
        {
          y: `${50 * this.VARS.DIRECTION}%`,
        },
        {
          y: "0%",
          duration: this.VARS.EASE.DURATION,
          ease: this.VARS.EASE.TYPE,
          onStart: () => {
            gsap.set(DOM.activeSlide, { zIndex: 15 });
          },
        }
      ),
    ]).add(() => {
      // Reset Context
      this.setActive();
      for (let [i, slide] of this.ref.slide.entries()) {
        gsap.set(slide, { clearProps: "zIndex" });
        gsap.set(slide.querySelector(".fxVisualContainer"), {
          clearProps: "y",
        });
      }
      this.VARS.IS_ANIMATING = false;
      this.VARS.CURRENT_SLIDE = this.VARS.NEW_SLIDE;
    });
  }

  setActive() {
    for (let [i, slide] of this.ref.slide.entries()) {
      if (i == this.VARS.NEW_SLIDE) {
        slide.classList.add("is-active");
      } else {
        slide.classList.remove("is-active");
      }
    }
  }

  triggerScroll(index) {
    if (this.VARS.IS_ANIMATING == false && index != this.VARS.CURRENT_SLIDE) {
      this.VARS.NEW_SLIDE = index;
      this.move();
    }
  }

  unmount() {
    if (typeof this.sticky != "undefined") {
      this.sticky.kill(true);
    }
    if (this.FX.targets.length) {
      for (let target of this.FX.targets) {
        target.kill(true);
      }
    }
  }
}
